module.exports = __webpack_public_path__ + "img/14.985e7f6f.jpg";